import { bars } from './bars';
import { slices } from './slices';
import { rows } from './rows';

export default {
  bar: bars,
  slice: slices,
  rows,
};
